import { ManagementEntity } from '../../organization/dto/ManagementEntity';
import { Organization } from '../../organization/dto/Organization';
import { FundOrderDTO } from '../../organization/dto/FundOrderDTO';

export class Fund {
  public id?: number;
  public name?: string;
  public registration?: string;
  public registrationDate?: Date;
  public initialClosing?: Date;
  public finalClosing?: string;
  public investmentPeriod?: string;
  public fundTerm?: string;
  public uuid?: string;
  public fundId?: string;
  public registrationNumber?: string;
  public expectedOpEx?: number = 0;
  public investmentLimit?: number = 0;
  public managementCompany?: ManagementEntity;
  public order: FundOrderDTO;
  public spv: boolean;
  public isUsedInStatistics: boolean;
}

export class FundWithOrg extends Fund {
  org: Organization;
}

export const FundSorting = {
  byId: (f: Fund): number => f.id,

  /**
  * fundId is represented as a string in the database for accounting purposes, allowing leading zeros to be added to the number.
  * For sorting, each `fundId` should be converted to a number to ensure correct numerical order.
  * Ensures that `fundId` is not `null` or `undefined`, defaulting to `0` if missing.
 */
  byFundId: (f: Fund): number => Number(f.fundId ?? 0),
  byName: (f: Fund): string => f.name,
  byRegistrationDate: (f: Fund): Date => f.registrationDate,
  byRegistrationNumber: (f: Fund): string => f.registrationNumber,
  byIsUsedInStatistics: (f: Fund): boolean => f.isUsedInStatistics,
  byRegistrationState: (f: Fund): string => f.registration,
  byInitClosing: (f: Fund): Date => f.initialClosing,
  byFinClosing: (f: Fund): string => f.finalClosing,
  byInvPeriod: (f: Fund): string => f.investmentPeriod,
  byFundTerm: (f: Fund): string => f.fundTerm,
  byManagementCompanyName: (f: Fund): string => f.managementCompany.name,
};

export class FundBasicInfo {
  id: number;
  uuid: string;
  name: string;
}
